// utils/hod.utils.ts

/**
 * Designation names that mean "Head of Department".
 * Compared after normalising case, underscores/hyphens and extra whitespace,
 * so `HOD`, `hod `, `head_of_department` and `Head Of Department` all match.
 */
const HOD_DESIGNATION_NAMES = ["hod", "head of department"];

const normalize = (value: string) =>
  value.trim().toLowerCase().replace(/[_-]+/g, " ").replace(/\s+/g, " ");

/** True when a staff member's designation marks them as an HOD. */
export const isHodDesignation = (
  designationName: string | null | undefined
): boolean =>
  !!designationName &&
  HOD_DESIGNATION_NAMES.includes(normalize(designationName));
